// Source - https://stackoverflow.com/a/79517693
// Posted by yoocodeur, modified by community. See post 'Timeline' for change history
// Retrieved 2026-10-02, License - CC BY-SA 4.0

export function applyGoogleTranslateFix() {
  if (
    typeof window !== "undefined" &&
    !(window as any).__googleTranslateFixApplied
  ) {
    const originalRemoveChild = Node.prototype.removeChild;

    (Node as any).prototype.removeChild = function (child) {
      try {
        return originalRemoveChild.call(this, child);
      } catch (error: any) {
        if (error.name === "NotFoundError") {
          // Prevents crashes by ignoring the error
          return child;
        }
        throw error;
      }
    };

    const originalInsertBefore = Node.prototype.insertBefore;

    (Node as any).prototype.insertBefore = function (newNode, referenceNode) {
      try {
        return originalInsertBefore.call(this, newNode, referenceNode);
      } catch (error: any) {
        if (error.name === "NotFoundError") {
          // If insertion fails, append the element instead
          return this.appendChild(newNode);
        }
        throw error;
      }
    };

    (window as any).__googleTranslateFixApplied = true;
  }
}
